import {View, ViewProps} from 'react-native';
import React from 'react';
import {useStyles} from '../../hooks/styles';
import {DeviceSize, maxDesktopContentWidth} from '../../theme/helpers';

export const Container = ({children, style, ...props}: React.PropsWithChildren<ViewProps>) => {
  const styles = useStyles(({mediaOnly}) => ({
    container: {
      marginLeft: 'auto',
      marginRight: 'auto',
      ...mediaOnly(
        DeviceSize.desktop,
        {maxWidth: maxDesktopContentWidth, paddingHorizontal: 24},
        {paddingHorizontal: 16},
      ),
      width: '100%',
    },
  }));
  return (
    <View style={[styles.container, style]} {...props}>
      {children}
    </View>
  );
};
